function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

class CartPerformance {
  static #metric_prefix = "cart-performance"

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    return performance.mark(`${metricName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp
    });

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      startMarker.name,
      `${metricName}:end`
    );
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`);

    callback();

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = null;
    this.btnMinus = null;
    this.btnPlus = null;
  }

  connectedCallback() {
    this.input = this.querySelector('input[type="number"]');
    this.btnMinus = this.querySelector('.qty-minus-btn');
    this.btnPlus = this.querySelector('.qty-plus-btn');

    // Set default min value
    if (this.input) {
      this.input.setAttribute('min', '1');
    }

    // Event listeners
    if (this.btnMinus) {
      this.btnMinus.addEventListener('click', this.decrease.bind(this));
    }

    if (this.btnPlus) {
      this.btnPlus.addEventListener('click', this.increase.bind(this));
    }

    if (this.input) {
      this.input.addEventListener('input', this.validateMin.bind(this));
    }
  }

  decrease(e) {
    e.preventDefault();
    const current = parseInt(this.input.value) || 1;
    if (current > 1) {
      this.input.value = current - 1;
      this.triggerChange();
    }
  }

  increase(e) {
    e.preventDefault();
    const current = parseInt(this.input.value) || 1;
    this.input.value = current + 1;
    this.triggerChange();
  }

  validateMin() {
    if (parseInt(this.input.value) < 1 || isNaN(this.input.value)) {
      this.input.value = 1;
      this.triggerChange();
    }
  }

  triggerChange() {
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

// Register the custom element
customElements.define('quantity-input', QuantityInput);

document.addEventListener("DOMContentLoaded", event => {
  function headerspace() {
    if (window.innerWidth < 769) {
      const header = document.querySelector(".site-header");
      const headerHeight = header ? header.offsetHeight : 0;

      document.querySelectorAll(".menu-wrapper").forEach(el => {
        el.style.paddingTop = headerHeight + "px";
      });
    } else {
      document.querySelectorAll(".menu-wrapper").forEach(el => {
        el.style.paddingTop = "0px";
      });
    }
  }
  headerspace();
  ["resize", "load", "scroll", "orientationchange"].forEach(event => {
    window.addEventListener(event, headerspace);
  });


  //--------- Main Menu Js [Globle] ---------
  document.body.addEventListener("click", function (e) {
    if (window.innerWidth < 769) {
      const btn = e.target.closest(".header-content .menu-btn");
      if (btn) {
        e.preventDefault(); 
        btn.classList.toggle("active"); 
        const nextEl = btn.nextElementSibling;
        if (nextEl && nextEl.classList.contains("menu-wrapper")) {
          nextEl.classList.toggle("open");
        } 
        document.body.classList.toggle("overflow-hidden");
      }
    }
  });


  //--------- Search Js [Globle] ---------
  document.body.addEventListener("click", function (e) {
    if (e.target.closest(".search-wrapper .search-btn")) {
      e.preventDefault();
      document.querySelector(".search-bar").classList.add("open");
      document.body.classList.add("overflow-hidden");
    }
  });
  document.body.addEventListener("click", function (e) {
    if (e.target.closest(".search-form .seach-close")) {
      e.preventDefault();
      document.querySelector(".search-bar").classList.remove("open");
      document.body.classList.remove("overflow-hidden");
    }
  });


  //--------- Recommended Swiper Js [PDP Page] ---------
  var thumb_product_swiper = new Swiper(".thumb-product-carousel", {
    direction: "vertical",
    spaceBetween: 16,
    slidesPerView: 3,
    watchSlidesProgress: true,
    breakpoints: {
      1025: {
        slidesPerView: 3,
        direction: "vertical",
      },
      992: {
        slidesPerView: 3,
        direction: "vertical",
      },
      319: {
        slidesPerView: 3,
        direction: "horizontal",
      }
    }
  });
  var main_product_swiper = new Swiper(".main-product-carousel", {
    spaceBetween: 16,
    thumbs: {
      swiper: thumb_product_swiper,
    },
  });
  // Vertical Thumb Slider Height
  function product_carouselHeight() {
    if (window.innerWidth > 991) {
      const main_product_carousel = document.querySelector(".main-product-carousel .product-img");
      const thumb_carouselHeight = main_product_carousel ? main_product_carousel.offsetHeight : 0;
      document.querySelectorAll(".thumb-product-carousel").forEach(el => {
        el.style.height = thumb_carouselHeight + "px";
      });
    } else {
      document.querySelectorAll(".thumb-product-carousel").forEach(el => {
        el.style.removeProperty("height");
      });
    }
  }
  product_carouselHeight();
  ["resize", "load", "scroll", "orientationchange"].forEach(event => {
    window.addEventListener(event, product_carouselHeight);
  });


  //--------- Recommended Product Swiper Js [PDP Page] ---------
  var recommended_swiper = new Swiper(".recommended-carousel", {
    slidesPerView: 4,
    spaceBetween: 30,
    breakpoints: {
      1025: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 3,
      },
      481: {
        slidesPerView: 2,
      },
      319: {
        slidesPerView: 1,
      }
    }
  });


  //--------- Relevant Blog Swiper Js [PDP Page] ---------
  var recommended_swiper = new Swiper(".relevant-blog-carousel", {
    slidesPerView: 3,
    spaceBetween: 35,
    navigation: {
      nextEl: ".relevant-blog-carousel-wrapper .swiper-button-next",
      prevEl: ".relevant-blog-carousel-wrapper .swiper-button-prev",
    },
    breakpoints: {
      851: {
        slidesPerView: 3,
      },
      576: {
        slidesPerView: 2,
      },
      319: {
        slidesPerView: 1,
      }
    }
  });
});

// Accordions Js
const accordions = document.querySelectorAll("[data-accordion-title]");
if (window.innerWidth < 1025) {
    accordions.forEach((accordion) => {
        accordion.addEventListener("click", (e) => {
            e.stopPropagation();

            const isActive = accordion.classList.contains("active");
            const group = accordion.closest("[data-accordion]"); // only this group

            // Close siblings in the same group
            group.querySelectorAll(":scope > [data-accordion-title]").forEach((item) => {
                item.classList.remove("active");
                if (item.nextElementSibling) {
                    item.nextElementSibling.style.maxHeight = null;
                }
            });

            group.parentElement.querySelectorAll("[data-accordion-title]").forEach((item) => {
                item.classList.remove("active");
                if (item.nextElementSibling) {
                    item.nextElementSibling.style.maxHeight = null;
                }
            });

            // Toggle clicked accordion
            if (!isActive) {
                accordion.classList.add("active");
                if (accordion.nextElementSibling) {
                    accordion.nextElementSibling.style.maxHeight =
                    accordion.nextElementSibling.scrollHeight + "px";
                }
            }
        });
    });
}
document.querySelectorAll(".read-more").forEach(function (btn) {
  btn.style.display = "inline-block"; // show button if hidden in liquid

  btn.addEventListener("click", function (e) {
    e.preventDefault();

    const wrapper = btn.closest(".rte-block");
    const defaultContent = wrapper.querySelector(".default-content");
    const fullContent = wrapper.querySelector(".full-content");

    if (fullContent.style.display == "none") {
      // Show full content
      // defaultContent.style.display = "none";
      fullContent.style.display = "block";
      btn.textContent = "Read Less...";
    } else {
      // Show excerpt
      // defaultContent.style.display = "block";
      fullContent.style.display = "none";
      btn.textContent = "Read More...";
    }
  });
});
